import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=4e61e23f&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61e23f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e61e23f')) {
      api.createRecord('4e61e23f', component.options)
    } else {
      api.reload('4e61e23f', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=4e61e23f&scoped=true&", function () {
      api.rerender('4e61e23f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Email.vue"
export default component.exports